import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import {
  FileUploadError,
  FileListView,
  FileDropZone,
  FileChoose,
} from '../../../../../../../common/fileUpload/components/FileUpload/components';
import { mapDocumentToFieldValue } from '../../../../../../../common/fileUpload/mappers';
import { IPhotoProps } from './types';
import styles from './Photo.css';

import { useDropzone } from 'react-dropzone';
import { useCallback } from 'react';

export const Photo: React.FC<IPhotoProps> = props => {
  const { error, value, handleFileRemove, handleFileSelect, handleFileRotate, handleFilesMove } = props;

  const onDrop = useCallback(
    acceptedFiles => {
      handleFileSelect(acceptedFiles);
    },
    [handleFileSelect],
  );

  const { getRootProps, isDragActive } = useDropzone({ onDrop, noClick: true });

  const isDesktop = useDeviceType() === 'desktop';

  const uploadButton = (
    <FileChoose
      onFileSelect={handleFileSelect}
      multiple
      buttonText={isDesktop ? 'Выберите файлы' : 'Добавить фото'}
      accept="image/png, image/jpeg, image/gif"
    />
  );

  return (
    <div {...getRootProps()}>
      <div className={styles['container']}>
        {value && value.length > 0 ? (
          <FileListView
            list={value.map(mapDocumentToFieldValue)}
            onDelete={handleFileRemove}
            onRotate={handleFileRotate}
            onMove={handleFilesMove}
            content={value.length < 5 && uploadButton}
          />
        ) : (
          <div className={styles['upload-button']}>{uploadButton}</div>
        )}
      </div>

      {isDragActive && <FileDropZone />}

      {error && <FileUploadError error={error} />}
    </div>
  );
};
